<template>
<div  class="is-content">
    {{ (msg.contentDetail && msg.contentDetail.content) || settings.assistWele || $t('pc_biz_ai_question_default_tips').d('你好，我是AI助手，很高兴为你服务！') }}
    <div class="promot-content">
        <div :class="{'promot-header': true, 'fullscreen-promot-header': fullscreen}">
            <div class="mt8">
                {{ $t('pc_biz_ai_promot_tips').d('你可以试着这样问我：') }}
            </div>
            <div @click="changeList" class="changeList">
                <yxtf-svg class="icon-copy" width="20px" height="20px" icon-class="turn-right" />
                <span>{{ $t('pc_biz_ai_change_promot').d('换一换') }}</span>
            </div>
        </div>
        <div class="promot-list" :class="{'promot-space':!fullscreen, 'fullscreen-promot': fullscreen}">
            <div class="promot-list-item" v-for="item in promots" :key="item" @click="promptClick(item)">
                <div class="list-item">
                    <span class="point"></span>{{ item }}
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
  getWeekHot
} from '../../service';
export default {
  name: 'questionPromot',
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
    msg: { // 回答的消息体
      type: Object,
      default: () => {}
    }
  },
  inject: ['settings'],
  data() {
    return {
      startIndex: 0,
      promots: [],
      promotList: [
        'AI助手是什么？',
        '如何快速的找到我需要参与的培训项目？',
        '如何成为一名企业讲师？',
        '如何跟踪自己的学习进度？',
        '如何参与课程的讨论与互动？',
        '如何有效和他人沟通？',
        'AI助手可以帮助我做什么？',
        '课程找不到怎么办？',
        '如何获得更多学习平台积分？',
        '提升自主学习能力的方式？',
        '项目如何吸引更多学员参与？',
        '有效的项目管理方法',
        '关于数字化人才发展'
      ]
    };
  },
  mounted() {
    this.getWeekHot();
  },
  computed: {
    showPromotNums() {
      if (this.fullscreen) {
        return 6;
      } else {
        return 3;
      }
    }
  },
  watch: {
    fullscreen: function() {
      this.changeList();
    }
  },
  methods: {
    getWeekHot() { // 获取提问热词
      getWeekHot().then(res => {
        console.log('getWeekHot', res);
        if (res.length) {
          let words = res.map(item => item.word);
          if (words.length > 11) { // 根据热词数量插入热词
            this.promotList.unshift(...words.slice(0, 11));
          } else if (words.length > 5) {
            this.promotList.unshift(...words.slice(0, 5));
          }
        }
        console.log('this.promotList', this.promotList);
        this.changeList();
        this.$emit('scrollToEnd');
      });
    },
    changeList() {
      if ((this.startIndex + this.showPromotNums) <= this.promotList.length) {
        this.promots = this.promotList.slice(this.startIndex, this.startIndex + this.showPromotNums);
      } else {
        this.startIndex = 0;
        this.promots = this.promotList.slice(this.startIndex, this.startIndex + this.showPromotNums);
      }
      this.startIndex += this.showPromotNums;
    },
    promptClick(item) {
      this.$emit('PromotClick', item);
    }
  }
};
</script>

<style lang="scss" scoped>
.promot-content {
    .promot-header {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: #595959;
        line-height: 28px;

        .changeList {
            cursor: pointer;
            display: flex;
            align-items: center;

            &:hover {
                color: var(--color-primary-6);
            }
        }
    }
    .fullscreen-promot-header {
      font-size: 16px;
    }

    .promot-list {
        .promot-list-item {
            margin-top: 8px;
            background: #F4F5F6;
            border-radius: 0px 12px 12px 12px;
            box-sizing: border-box;
            font-size: 14px;
            font-weight: 400;
            color: #262626;
            padding: 8px 16px;
            line-height: 28px;
            cursor: pointer;

            .list-item {
                overflow: hidden;
                box-sizing: border-box;
                text-overflow: ellipsis;

                .point {
                    line-height: 28px;
                    display: inline-block;
                    width: 8px;
                    height: 8px;
                    margin-right: 10px;
                    border: 1px solid #262626;
                    background: #fff;
                    border-radius: 50%;
                }
            }
        }

        &.fullscreen-promot {
            display: flex;
            flex-wrap: wrap;

            .promot-list-item {
                width: calc(33% - 8px);
                padding-top: 8px;
                margin-right: 16px;
                font-size: 16px;
                &:nth-child(3n) {
                    margin-right: 0px;
                }

                .list-item {
                    word-break: break-all;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    /* 这里是超出几行省略 */
                    overflow: hidden;
                }
            }
        }

        &.promot-space {
            .promot-list-item {
                .list-item {
                    white-space: nowrap;
                }
            }
        }
    }
}
</style>
